(function (angular) {
    'use strict';

    angular
        .module('app')
        .controller('app.mainController', ['$rootScope', '$scope', '$state', '$timeout', '$uibModal', mainController]);

    function mainController($rootScope, $scope, $state, $timeout, $uibModal) {
        var vm = this;
        vm.$state = $state;
        $scope.localState = '';
        vm.on = true;
        vm.ogSgdpHeader = true;
        $rootScope.locationModalOpen = false;
        vm.isOpenLocationModal = $rootScope.isOpenLocationModal;
        $scope.$watch('$rootScope.isOpenLocationModal', function (newVal, oldVal) {
            if (newVal == true) {
                $timeout(function () {
                    openLocationModal(true);
                }, 200);
                $rootScope.isOpenLocationModal = null;
            }
        });

        initialize();

        function initialize() {
            if (!$scope.localState) {
                $timeout(function () {
                    openLocationModal(false);
                }, 200);
            }
            // openLocationModal();
            // launchInvite();
        }

        function openLocationModal(isForce) {
            if ((!$rootScope.locationModalOpen || isForce) && !siteContent.hideLocationModal) {
                $rootScope.locationModalOpen = true;
                $uibModal
                    .open({
                        templateUrl: '/app/site/landing-flow/location/location-modal.html',
                        controller: 'app.landing.locationModalController',
                        controllerAs: 'vm',
                        keyboard: false
                    })
                    .result.then(function fulfilled(state) {
                        vm.on = false;
                        $scope.$apply();
                        $scope.localState = state;
                        if (state == 'CA') {
                            vm.ogSgdpHeader = false;
                        } else {
                            vm.ogSgdpHeader = true;
                        }
                        vm.on = true;
                    });
            }
        }
    }
})(angular);
